/**
 * Widget config — mapping type de nœud → widget visuel
 * Les clés correspondent directement au champ `type` du modèle Noeud
 */
const WIDGET_CONFIGS = {
  // ─── Capteurs ───────────────────────────────────────────────
  'Capteur Température': {
    component: 'thermometer',
    unit: '°C',
    color: '#3B82F6',
    min: -10,
    max: 50,
  },
  'Capteur Humidité': {
    component: 'gauge',
    unit: '%',
    color: '#14B8A6',
    min: 0,
    max: 100,
    thresholds: [
      { value: 30, color: '#F59E0B' },
      { value: 60, color: '#14B8A6' },
      { value: 80, color: '#3B82F6' },
    ],
  },
  'Capteur Pression': {
    component: 'gauge',
    unit: 'hPa',
    color: '#F97316',
    min: 900,
    max: 1100,
  },
  'Capteur CO2': {
    component: 'gauge',
    unit: 'ppm',
    color: '#8B5CF6',
    min: 0,
    max: 2000,
    thresholds: [
      { value: 800, color: '#22C55E' },
      { value: 1200, color: '#F59E0B' },
      { value: 2000, color: '#EF4444' },
    ],
  },
  'Capteur Qualité Air': {
    component: 'gauge',
    unit: 'AQI',
    color: '#22C55E',
    min: 0,
    max: 300,
    thresholds: [
      { value: 50, color: '#22C55E' },
      { value: 100, color: '#F59E0B' },
      { value: 150, color: '#F97316' },
      { value: 300, color: '#EF4444' },
    ],
  },
  'Caméra IP': {
    component: 'state',
    unit: '',
    color: '#6B7280',
    min: 0,
    max: 1,
  },

  // ─── Actionneurs ────────────────────────────────────────────
  'Climatisation': { component: 'state', unit: '', color: '#22C55E', min: 0, max: 1 },
  'Ventilation':   { component: 'state', unit: '', color: '#22C55E', min: 0, max: 1 },
  'Relais':        { component: 'state', unit: '', color: '#22C55E', min: 0, max: 1 },
  'Moteur':        { component: 'state', unit: '', color: '#22C55E', min: 0, max: 1 },
  'Lumière':       { component: 'state', unit: '', color: '#22C55E', min: 0, max: 1 },
  'Thermostat':    { component: 'state', unit: '°C', color: '#22C55E', min: 0, max: 1 },
  'Vanne':         { component: 'state', unit: '', color: '#22C55E', min: 0, max: 1 },
  'Électrovanne':  { component: 'state', unit: '', color: '#22C55E', min: 0, max: 1 },

  // ─── Passerelles ────────────────────────────────────────────
  'Gateway LoRa':  { component: 'uptime', unit: '%', color: '#10B981', min: 0, max: 100 },
  'Gateway WiFi':  { component: 'uptime', unit: '%', color: '#10B981', min: 0, max: 100 },
  'Gateway 4G':    { component: 'uptime', unit: '%', color: '#10B981', min: 0, max: 100 },
};

/**
 * Retourne la config widget pour un type de nœud donné
 * @param {string} type      - ex: "Capteur Température", "Relais", "Gateway LoRa"
 * @param {string} categorie - ex: "Capteur", "Actionneur", "Passerelle"
 */
export function getWidgetConfig(type, categorie) {
  // Match direct par type
  if (WIDGET_CONFIGS[type]) {
    return { ...WIDGET_CONFIGS[type] };
  }

  // Fallback par catégorie
  if (categorie === 'Actionneur') {
    return { component: 'state', unit: '', color: '#22C55E', min: 0, max: 1 };
  }
  if (categorie === 'Passerelle') {
    return { component: 'uptime', unit: '%', color: '#10B981', min: 0, max: 100 };
  }

  // Défaut : gauge générique
  return { component: 'gauge', unit: '', color: '#6B7280', min: 0, max: 100 };
}

export default WIDGET_CONFIGS;
